/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { WorkflowTemplatesControllerCreateMutationRequest, WorkflowTemplatesControllerCreateMutationResponse, WorkflowTemplatesControllerCreate400, WorkflowTemplatesControllerCreate401, WorkflowTemplatesControllerCreate403 } from "../../models/workflowsController/WorkflowTemplatesControllerCreate";

function getWorkflowTemplatesControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/workflow-templates` as const }  
  return res
}

/**
 * @summary Create a new workflow template
 * {@link /api/v1/workflow-templates}
 */
export async function workflowTemplatesControllerCreate(data?: WorkflowTemplatesControllerCreateMutationRequest, config: Partial<RequestConfig<WorkflowTemplatesControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<WorkflowTemplatesControllerCreateMutationResponse, ResponseErrorConfig<WorkflowTemplatesControllerCreate400 | WorkflowTemplatesControllerCreate401 | WorkflowTemplatesControllerCreate403>, WorkflowTemplatesControllerCreateMutationRequest>({ method : "POST", url : getWorkflowTemplatesControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}